export default __webpack_public_path__ + "static/media/plus-white.ab783921.svg";